import { computed, Injectable, signal } from '@angular/core';
import { SELECTED_COMPANY_KEY, SelectedCompany } from './selected-company';

@Injectable({
  providedIn: 'root',
})
export class CompanyContextService {
  private readonly _selected = signal<SelectedCompany | null>(this.loadFromStorage());

  readonly selected = this._selected.asReadonly();
  readonly selectedName = computed(() => this._selected()?.name ?? null);
  readonly currencyCode = computed(() => this._selected()?.currencyCode ?? '');
  readonly currencySymbol = computed(() => this._selected()?.currencySymbol ?? '');

  select(company: SelectedCompany): void {
    const value: SelectedCompany = {
      id: company.id,
      tenantId: company.tenantId,
      name: company.name,
      currencyCode: company.currencyCode,
      currencySymbol: company.currencySymbol,
    };
    this._selected.set(value);
    localStorage.setItem(SELECTED_COMPANY_KEY, JSON.stringify(value));
  }

  clearSelection(): void {
    this._selected.set(null);
    localStorage.removeItem(SELECTED_COMPANY_KEY);
  }

  private loadFromStorage(): SelectedCompany | null {
    try {
      const raw = localStorage.getItem(SELECTED_COMPANY_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (
        typeof parsed?.id === 'string' &&
        parsed.id &&
        typeof parsed?.tenantId === 'string' &&
        parsed.tenantId &&
        typeof parsed?.name === 'string' &&
        parsed.name
      ) {
        return {
          id: parsed.id,
          tenantId: parsed.tenantId,
          name: parsed.name,
          currencyCode: typeof parsed.currencyCode === 'string' ? parsed.currencyCode : undefined,
          currencySymbol:
            typeof parsed.currencySymbol === 'string' ? parsed.currencySymbol : undefined,
        };
      }
      return null;
    } catch {
      return null;
    }
  }
}
